import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import * as Queries from '@api/graphql/queries';
import { connect } from 'react-redux';
import { ApplicationState } from 'reducers';
import {
    ProductCategory as ProductCategoryType,
    updateProductCategoryVariables,
} from '@api/graphql/types';
import ProductCategoryForm from '../components/ProductCategoryForm';

type Props = {
    productCategoryId?: string,
} & InjectedIntlProps & RouteComponentProps<{productCategoryId: string}>;

interface State {
    formData: updateProductCategoryVariables;
}

class ProductCategoryEdit extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: {
                id: '',
                name: '',
                parent_id: null,
                url_key: '',
                content: '',
                is_enable: true,
                date_from: null,
                date_to: null,
                show_in_menu: true,
                keywords: '',
                description: '',
                is_promotion: false,
                is_homepage_prohibited: false,
            },
        };
    }

    public componentDidMount() {
        GraphQLClient.query<ProductCategoryType>({
            query: Queries.productCategory,
            variables: {id: this.props.match.params.productCategoryId},
        }).then((response) => {
            if (response.data && response.data.adminProductCategoryById) {
                const result = response.data.adminProductCategoryById;
                const formData = {
                    id: result.id,
                    name: result.name,
                    parent_id: result.parent_id,
                    url_key: result.url_key,
                    content: result.content,
                    is_enable: result.is_enable,
                    date_from: result.date_from,
                    date_to: result.date_to,
                    show_in_menu: !!result.show_in_menu,
                    keywords: result.keywords,
                    description: result.description,
                    is_promotion: result.is_promotion,
                    is_homepage_prohibited: result.is_homepage_prohibited,
                };
                this.setState({ formData });
            }
        });
    }

    public onSubmit = (variables: updateProductCategoryVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.updateProductCategory,
            variables,
        });
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                    <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({ id: 'module.productCategory.edit.title'})}</h5>
                        </div>
                        <div className="ibox-content">
                            <ProductCategoryForm formData={this.state.formData} onSubmit={this.onSubmit} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState, props: Props) => {
    const { productCategoryId } = props.match.params;
    return { productCategoryId };
};

export default compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(ProductCategoryEdit);



// WEBPACK FOOTER //
// ./src/modules/ProductCategory/pages/ProductCategoryEdit.tsx